var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4449",
    "data-name": "Rectangle 4449",
    width: 24,
    height: 24,
    transform: "translate(60 479)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vendor",
    transform: "translate(-60 -479)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delivery_Man_1_",
    transform: "translate(43.143 461.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8445",
    "data-name": "Group 8445",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11103",
    "data-name": "Path 11103",
    d: "M336.608,338.144h-3.072A1.536,1.536,0,0,1,332,336.608v-3.072A1.536,1.536,0,0,1,333.536,332h3.072a1.536,1.536,0,0,1,1.536,1.536v3.072A1.536,1.536,0,0,1,336.608,338.144Z",
    transform: "translate(-320.429 -319.747)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1092",
    "data-name": "Line 1092",
    y2: 1.754,
    transform: "translate(14.499 12.185)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11104",
    "data-name": "Path 11104",
    d: "M29.215,268.071h-7.68A1.536,1.536,0,0,1,20,266.535V265.41a5.019,5.019,0,0,1,4.619-5",
    transform: "translate(-20 -250.903)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11105",
    "data-name": "Path 11105",
    d: "M300,260a4.609,4.609,0,0,1,4.224,2.765",
    transform: "translate(-289.565 -250.621)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11106",
    "data-name": "Path 11106",
    d: "M127.68,26.912a3.84,3.84,0,0,1-7.68,0V22.3a2.3,2.3,0,0,1,2.3-2.3h3.072a2.3,2.3,0,0,1,2.3,2.3Z",
    transform: "translate(-116.311 -20)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1093",
    "data-name": "Line 1093",
    y2: 1.754,
    transform: "translate(7.715 10.996)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11107",
    "data-name": "Path 11107",
    d: "M127.68,101.536c-1.5,0-2.34-1.536-3.84-1.536s-2.34,1.536-3.84,1.536",
    transform: "translate(-116.311 -96.877)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1094",
    "data-name": "Line 1094",
    x2: 1.169,
    transform: "translate(3.138 13.946)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorActiveIcon);
export default __webpack_public_path__ + "static/media/Vendor_Active_icon.8ca1ffe25cb33fee74ff7c26d78fb0fd.svg";
export { ForwardRef as ReactComponent };